<template>
  <div>
    <ManageAssistantTeacherBar />

    <!-- App Bar with Mode Toggle -->
    <v-toolbar color="primary" dark dense elevation="2">
      <v-toolbar-title>
        <v-icon left>mdi-clipboard-flow</v-icon>
        ระบบจัดการเลขที่ตำแหน่ง รอบที่
        {{ periodassteachs.periodAssTeachTimes }}/{{
          periodassteachs.periodAssTeachYear
        }}
      </v-toolbar-title>
      <v-spacer></v-spacer>

      <v-chip class="mr-4" color="white" text-color="primary" label>
        <v-icon left small>mdi-office-building</v-icon>
        ทั้งหมด: {{ statistics.total }} ตำแหน่ง
      </v-chip>

      <v-btn-toggle
        v-model="viewMode"
        mandatory
        dense
        color="info"
        class="mr-2 success--text"
      >
        <v-btn value="admin" small>
          <v-icon left small>mdi-cog</v-icon>
          จัดการ
        </v-btn>
        <v-btn value="display" small>
          <v-icon left small>mdi-monitor</v-icon>
          สถิติ
        </v-btn>
      </v-btn-toggle>

      <v-btn icon @click="toggleFullscreen" class="mr-1">
        <v-icon>{{
          isFullscreen ? "mdi-fullscreen-exit" : "mdi-fullscreen"
        }}</v-icon>
      </v-btn>

      <v-btn
        icon
        @click="toggleAutoRefresh"
        :color="autoRefresh ? 'green' : ''"
      >
        <v-icon>mdi-refresh</v-icon>
      </v-btn>
    </v-toolbar>

    <!-- Display Mode (Statistics & Charts) -->
    <div v-if="viewMode === 'display'" class="display-mode">
      <v-container fluid class="pa-6 grey lighten-4">
        <!-- Header -->
        <v-row class="mb-4">
          <v-col cols="12">
            <v-card class="elevation-8" color="primary" dark>
              <v-card-title class="text-h4 justify-center py-6">
                <v-icon x-large left>mdi-chart-box</v-icon>
                สถิติเลขที่ตำแหน่งรายงานตัว
              </v-card-title>
              <v-card-subtitle class="text-center text-h6 pb-4">
                รอบที่ {{ periodassteachs.periodAssTeachTimes }} /
                {{ periodassteachs.periodAssTeachYear }}
                <v-chip class="ml-4" color="white" text-color="primary" large>
                  <v-icon left>mdi-clock</v-icon>
                  {{ currentTime }}
                </v-chip>
              </v-card-subtitle>
            </v-card>
          </v-col>
        </v-row>

        <!-- Statistics Cards -->
        <v-row class="mb-4">
          <v-col cols="12" md="3">
            <v-card class="elevation-4" color="blue darken-1" dark>
              <v-card-text class="text-center">
                <v-icon size="60" class="mb-2">mdi-office-building</v-icon>
                <div class="text-h3 font-weight-bold">
                  {{ statistics.total }}
                </div>
                <div class="text-h6">จำนวนตำแหน่งทั้งหมด</div>
              </v-card-text>
            </v-card>
          </v-col>

          <v-col cols="12" md="3">
            <v-card class="elevation-4" color="green darken-1" dark>
              <v-card-text class="text-center">
                <v-icon size="60" class="mb-2">mdi-account-check</v-icon>
                <div class="text-h3 font-weight-bold">
                  {{ statistics.booked }}
                </div>
                <div class="text-h6">จองแล้ว</div>
                <v-progress-linear
                  :value="statistics.bookedPercent"
                  color="white"
                  height="8"
                  rounded
                  class="mt-2"
                ></v-progress-linear>
                <div class="text-caption mt-1">
                  {{ statistics.bookedPercent }}%
                </div>
              </v-card-text>
            </v-card>
          </v-col>

          <v-col cols="12" md="3">
            <v-card class="elevation-4" color="orange darken-1" dark>
              <v-card-text class="text-center">
                <v-icon size="60" class="mb-2">mdi-door-open</v-icon>
                <div class="text-h3 font-weight-bold">
                  {{ statistics.available }}
                </div>
                <div class="text-h6">ว่าง</div>
                <v-progress-linear
                  :value="statistics.availablePercent"
                  color="white"
                  height="8"
                  rounded
                  class="mt-2"
                ></v-progress-linear>
                <div class="text-caption mt-1">
                  {{ statistics.availablePercent }}%
                </div>
              </v-card-text>
            </v-card>
          </v-col>

          <v-col cols="12" md="3">
            <v-card class="elevation-4" color="purple darken-1" dark>
              <v-card-text class="text-center">
                <v-icon size="60" class="mb-2">mdi-domain</v-icon>
                <div class="text-h3 font-weight-bold">
                  {{ statistics.colleges }}
                </div>
                <div class="text-h6">จำนวนวิทยาลัย</div>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>

        <!-- Charts Row 1 -->
        <v-row class="mb-4">
          <v-col cols="12" md="6">
            <v-card class="elevation-4">
              <v-card-title class="primary white--text">
                <v-icon left color="white">mdi-chart-donut</v-icon>
                สัดส่วนสถานะตำแหน่ง
              </v-card-title>
              <v-card-text>
                <apexchart
                  type="donut"
                  height="350"
                  :options="donutChartOptions"
                  :series="donutChartSeries"
                ></apexchart>
              </v-card-text>
            </v-card>
          </v-col>

          <v-col cols="12" md="6">
            <v-card class="elevation-4">
              <v-card-title class="primary white--text">
                <v-icon left color="white">mdi-chart-bar</v-icon>
                ตำแหน่งแยกตามสาขา (Top 10)
              </v-card-title>
              <v-card-text>
                <apexchart
                  type="bar"
                  height="350"
                  :options="branchBarChartOptions"
                  :series="branchBarChartSeries"
                ></apexchart>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>

        <!-- Charts Row 2 -->
        <v-row class="mb-4">
          <v-col cols="12" md="6">
            <v-card class="elevation-4">
              <v-card-title class="primary white--text">
                <v-icon left color="white">mdi-map-marker</v-icon>
                จำนวนตำแหน่งแยกตามภาค
              </v-card-title>
              <v-card-text>
                <apexchart
                  type="bar"
                  height="350"
                  :options="regionBarChartOptions"
                  :series="regionBarChartSeries"
                ></apexchart>
              </v-card-text>
            </v-card>
          </v-col>

          <v-col cols="12" md="6">
            <v-card class="elevation-4">
              <v-card-title class="primary white--text">
                <v-icon left color="white">mdi-chart-line</v-icon>
                สถิติการใช้งานตำแหน่ง
              </v-card-title>
              <v-card-text>
                <apexchart
                  type="area"
                  height="350"
                  :options="areaChartOptions"
                  :series="areaChartSeries"
                ></apexchart>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>

        <!-- Top Colleges Table -->
        <v-row>
          <v-col cols="12">
            <v-card class="elevation-4">
              <v-card-title class="primary white--text">
                <v-icon left color="white">mdi-trophy</v-icon>
                วิทยาลัยที่มีตำแหน่งมากที่สุด (Top 15)
              </v-card-title>
              <v-card-text class="pa-0">
                <v-simple-table>
                  <template v-slot:default>
                    <thead>
                      <tr class="grey lighten-3">
                        <th class="text-center text-h6">อันดับ</th>
                        <th class="text-h6">วิทยาลัย</th>
                        <th class="text-h6">จังหวัด</th>
                        <th class="text-center text-h6">ทั้งหมด</th>
                        <th class="text-center text-h6">จองแล้ว</th>
                        <th class="text-center text-h6">ว่าง</th>
                        <th class="text-center text-h6">%ใช้งาน</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        v-for="(college, index) in topColleges"
                        :key="college.college_code"
                      >
                        <td class="text-center">
                          <v-chip
                            :color="index < 3 ? 'warning' : 'primary'"
                            dark
                            label
                          >
                            <v-icon v-if="index === 0" left small
                              >mdi-trophy</v-icon
                            >
                            <v-icon v-else-if="index === 1" left small
                              >mdi-medal</v-icon
                            >
                            <v-icon v-else-if="index === 2" left small
                              >mdi-podium</v-icon
                            >
                            <strong>{{ index + 1 }}</strong>
                          </v-chip>
                        </td>
                        <td>
                          <strong>{{ college.college_name }}</strong>
                        </td>
                        <td>{{ college.province_name }}</td>
                        <td class="text-center">
                          <v-chip color="info" dark>{{ college.total }}</v-chip>
                        </td>
                        <td class="text-center">
                          <v-chip color="success" dark>{{
                            college.booked
                          }}</v-chip>
                        </td>
                        <td class="text-center">
                          <v-chip color="orange" dark>{{
                            college.available
                          }}</v-chip>
                        </td>
                        <td class="text-center">
                          <v-progress-circular
                            :value="college.usagePercent"
                            :color="
                              college.usagePercent > 80
                                ? 'success'
                                : college.usagePercent > 50
                                ? 'warning'
                                : 'error'
                            "
                            :size="50"
                            :width="5"
                          >
                            {{ college.usagePercent }}%
                          </v-progress-circular>
                        </td>
                      </tr>
                    </tbody>
                  </template>
                </v-simple-table>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>

        <!-- Auto Refresh Indicator -->
        <v-snackbar
          v-model="showRefreshSnackbar"
          timeout="2000"
          color="success"
          bottom
          right
        >
          <v-icon left>mdi-refresh</v-icon>
          ข้อมูลอัพเดทแล้ว
        </v-snackbar>
      </v-container>
    </div>

    <!-- Admin Mode (Management View) -->
    <v-container v-else fluid class="admin-mode mt-4">
      <!-- Quick Statistics Cards (Smaller version for admin) -->
      <v-row class="mb-4">
        <v-col cols="12" md="3">
          <v-card class="elevation-2" color="blue lighten-5">
            <v-card-text>
              <div class="d-flex align-center">
                <v-avatar color="blue darken-2" size="48" class="mr-3">
                  <v-icon dark>mdi-office-building</v-icon>
                </v-avatar>
                <div>
                  <div
                    class="text-h5 font-weight-bold blue--text text--darken-2"
                  >
                    {{ statistics.total }}
                  </div>
                  <div class="text-subtitle-2">จำนวนตำแหน่ง</div>
                </div>
              </div>
            </v-card-text>
          </v-card>
        </v-col>

        <v-col cols="12" md="3">
          <v-card class="elevation-2" color="green lighten-5">
            <v-card-text>
              <div class="d-flex align-center">
                <v-avatar color="green darken-2" size="48" class="mr-3">
                  <v-icon dark>mdi-account-check</v-icon>
                </v-avatar>
                <div>
                  <div
                    class="text-h5 font-weight-bold green--text text--darken-2"
                  >
                    {{ statistics.booked }}
                  </div>
                  <div class="text-subtitle-2">
                    จองแล้ว ({{ statistics.bookedPercent }}%)
                  </div>
                </div>
              </div>
            </v-card-text>
          </v-card>
        </v-col>

        <v-col cols="12" md="3">
          <v-card class="elevation-2" color="orange lighten-5">
            <v-card-text>
              <div class="d-flex align-center">
                <v-avatar color="orange darken-2" size="48" class="mr-3">
                  <v-icon dark>mdi-door-open</v-icon>
                </v-avatar>
                <div>
                  <div
                    class="text-h5 font-weight-bold orange--text text--darken-2"
                  >
                    {{ statistics.available }}
                  </div>
                  <div class="text-subtitle-2">
                    ว่าง ({{ statistics.availablePercent }}%)
                  </div>
                </div>
              </div>
            </v-card-text>
          </v-card>
        </v-col>

        <v-col cols="12" md="3">
          <v-card class="elevation-2" color="purple lighten-5">
            <v-card-text>
              <div class="d-flex align-center">
                <v-avatar color="purple darken-2" size="48" class="mr-3">
                  <v-icon dark>mdi-domain</v-icon>
                </v-avatar>
                <div>
                  <div
                    class="text-h5 font-weight-bold purple--text text--darken-2"
                  >
                    {{ statistics.colleges }}
                  </div>
                  <div class="text-subtitle-2">วิทยาลัย</div>
                </div>
              </div>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>

      <!-- Mini Charts in Admin Mode -->
      <v-row class="mb-4">
        <v-col cols="12" md="6">
          <v-card class="elevation-2">
            <v-card-title class="primary white--text py-2">
              <v-icon left color="white" small>mdi-chart-bar</v-icon>
              <span class="text-subtitle-1">สาขาวิชา (Top 5)</span>
            </v-card-title>
            <v-card-text>
              <apexchart
                type="bar"
                height="200"
                :options="miniBarChartOptions"
                :series="miniBarChartSeries"
              ></apexchart>
            </v-card-text>
          </v-card>
        </v-col>

        <v-col cols="12" md="6">
          <v-card class="elevation-2">
            <v-card-title class="primary white--text py-2">
              <v-icon left color="white" small>mdi-chart-donut</v-icon>
              <span class="text-subtitle-1">สัดส่วนสถานะ</span>
            </v-card-title>
            <v-card-text>
              <apexchart
                type="donut"
                height="200"
                :options="miniDonutChartOptions"
                :series="donutChartSeries"
              ></apexchart>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>

      <!-- Main Management Card -->
      <base-material-card
        icon="mdi-clipboard-flow"
        :title="
          'ข้อมูลเลขที่ตำแหน่ง วิทยาลัย ใช้รายงานตัว รอบที่ : ' +
            periodassteachs.periodAssTeachTimes +
            ' / ' +
            periodassteachs.periodAssTeachYear
        "
        class="px-5 py-3"
      >
        <!-- Filter & Action Bar -->
        <v-card class="mb-4 pa-4" outlined>
          <v-row align="center">
            <v-col cols="12" md="8">
              <v-text-field
                v-model="search"
                append-icon="mdi-magnify"
                label="ค้นหา วิทยาลัย, เลขที่ตำแหน่ง, สาขาวิชา"
                single-line
                hide-details
                dense
                outlined
                clearable
              />
            </v-col>

            <v-col cols="12" md="4">
              <v-select
                v-model="statusFilter"
                label="กรองสถานะ"
                outlined
                dense
                clearable
                :items="statusFilterOptions"
              />
            </v-col>
          </v-row>

          <!-- Action Buttons -->
          <v-row class="mt-2">
            <v-col cols="12" class="d-flex flex-wrap">
              <v-btn
                color="primary"
                depressed
                class="mr-2 mb-2"
                @click="manage_college_manpowerAdd"
              >
                <v-icon left>mdi-plus-circle</v-icon>
                เพิ่มรายการ
              </v-btn>

              <v-btn
                color="success"
                depressed
                class="mr-2 mb-2"
                @click="manage_college_manpowerCSV"
              >
                <v-icon left>mdi-file-import</v-icon>
                นำเข้าข้อมูล
              </v-btn>

              <v-btn
                color="info"
                depressed
                class="mr-2 mb-2"
                @click="manage_college_manpowerTotal"
              >
                <v-icon left>mdi-chart-pie</v-icon>
                สรุปสถิติ
              </v-btn>

              <v-btn
                color="warning"
                depressed
                class="mb-2"
                @click="manage_college_manpowerQueryAll"
              >
                <v-icon left>mdi-refresh</v-icon>
                รีเฟรชข้อมูล
              </v-btn>
            </v-col>
          </v-row>
        </v-card>

        <!-- Data Table -->
        <v-data-table
          :loading="loading"
          :headers="headers"
          :items="filteredPositions"
          :search="search"
          group-by="mcm_id_branch"
          class="elevation-2"
          :items-per-page="25"
          :footer-props="{
            itemsPerPageOptions: [10, 25, 50, 100, -1],
            showFirstLastPage: true
          }"
        >
          <!-- Group Header -->
          <template v-slot:group.header="{ items, isOpen, toggle }">
            <th colspan="12" class="group-header">
              <v-btn icon small @click="toggle" class="mr-2">
                <v-icon>{{
                  isOpen ? "mdi-chevron-up" : "mdi-chevron-down"
                }}</v-icon>
              </v-btn>
              <v-chip color="primary" dark label class="mr-2">
                {{ items[0].mcm_id_branch }}
              </v-chip>
              <strong>{{ items[0].name_branch }}</strong>
              <v-chip small color="info" dark class="ml-2">
                {{ items.length }} ตำแหน่ง
              </v-chip>
            </th>
          </template>

          <!-- College DIF -->
          <template v-slot:item.college_dif="{ item }">
            <v-chip v-if="item.college_dif === '1' || item.college_dif === 1" color="warning" small>
              <v-icon left small>mdi-map-marker</v-icon>
              จชต.
            </v-chip>
          </template>

          <!-- Who Booking -->
          <template v-slot:item.whoBooking="{ item }">
            <v-chip v-if="item.mcm_id_card_booking" color="success" dark small>
              <v-icon left small>mdi-account-check</v-icon>
              จองแล้ว
            </v-chip>
            <v-chip v-else color="orange" dark small>
              <v-icon left small>mdi-door-open</v-icon>
              ว่าง
            </v-chip>
          </template>

          <!-- Edit Action -->
          <template v-slot:item.actions="{ item }">
            <v-btn
              v-if="item.mcm_status !== 'send' && item.mcm_status !== 'receipt'"
              icon
              color="warning"
              @click="
                manage_college_manpowerEdit(
                  item.mcm_times,
                  item.mcm_years,
                  item.mcm_id_position
                )
              "
            >
              <v-icon>mdi-pencil</v-icon>
            </v-btn>
            <v-icon v-else color="grey">mdi-lock</v-icon>
          </template>

          <!-- Delete Action -->
          <template v-slot:item.action_s="{ item }">
            <v-btn
              v-if="item.mcm_status !== 'send' && item.mcm_status !== 'receipt'"
              icon
              color="error"
              @click="
                manage_college_manpowerDelete(
                  item.mcm_times,
                  item.mcm_years,
                  item.mcm_id_position
                )
              "
            >
              <v-icon>mdi-delete</v-icon>
            </v-btn>
            <v-chip v-else color="orange" dark x-small>
              <v-icon x-small>mdi-lock</v-icon>
            </v-chip>
          </template>

          <!-- No Results -->
          <template v-slot:no-data>
            <v-alert type="info" outlined class="ma-4">
              <strong>ไม่พบข้อมูล</strong><br />
              ลองปรับเปลี่ยนตัวกรองหรือคำค้นหา
            </v-alert>
          </template>

          <template v-slot:no-results>
            <v-alert type="warning" outlined class="ma-4">
              ไม่พบผลลัพธ์สำหรับ "<strong>{{ search }}</strong
              >"
            </v-alert>
          </template>
        </v-data-table>
      </base-material-card>
    </v-container>

    <!-- Add Dialog -->
    <v-dialog
      v-model="addmanage_college_manpowerdialog"
      persistent
      max-width="900px"
    >
      <v-card>
        <v-card-title class="primary white--text">
          <v-icon left color="white">mdi-plus-circle</v-icon>
          เพิ่มเลขที่ตำแหน่ง
        </v-card-title>
        <v-card-text class="pt-4">
          <v-form ref="addmanage_college_manpowerform" lazy-validation>
            <v-row>
              <v-col cols="12" md="4">
                <v-autocomplete
                  :items="colleges"
                  item-text="college_name"
                  item-value="college_code"
                  outlined
                  label="วิทยาลัย"
                  v-model="addmanage_college_manpower.mcm_college_code"
                  required
                  :rules="[v => !!v || 'กรุณาเลือกวิทยาลัย']"
                  @change="jor18Query(), CollegeMPQuery()"
                >
                  <template v-slot:item="{ item }">
                    <v-list-item-content>
                      <v-list-item-title>{{
                        item.college_name
                      }}</v-list-item-title>
                      <v-list-item-subtitle>{{
                        item.province_name
                      }}</v-list-item-subtitle>
                    </v-list-item-content>
                  </template>
                </v-autocomplete>
              </v-col>

              <v-col cols="12" md="4">
                <v-autocomplete
                  :items="jor18s"
                  item-text="id_position"
                  item-value="id_position"
                  outlined
                  label="เลขที่ตำแหน่ง"
                  v-model="addmanage_college_manpower.mcm_id_position"
                  required
                  :rules="[v => !!v || 'กรุณาเลือกเลขที่ตำแหน่ง']"
                >
                  <template v-slot:item="{ item }">
                    <v-list-item-content>
                      <v-list-item-title>
                        <strong>{{ item.id_position }}</strong>
                      </v-list-item-title>
                      <v-list-item-subtitle>
                        {{ item.id_card || "ว่าง" }}
                      </v-list-item-subtitle>
                    </v-list-item-content>
                  </template>
                </v-autocomplete>
              </v-col>

              <v-col cols="12" md="4">
                <v-autocomplete
                  :items="branchs"
                  item-text="name_branch"
                  item-value="id_branch"
                  outlined
                  label="สาขาวิชา"
                  v-model="addmanage_college_manpower.mcm_id_branch"
                  required
                  :rules="[v => !!v || 'กรุณาเลือกสาขาวิชา']"
                >
                  <template v-slot:item="{ item }">
                    <v-list-item-content>
                      <v-list-item-title>
                        {{ item.id_branch }} : {{ item.name_branch }}
                      </v-list-item-title>
                    </v-list-item-content>
                  </template>
                </v-autocomplete>
              </v-col>

              <v-col cols="12">
                <v-data-table
                  :loading="loading"
                  :headers="headersCollegeBranch"
                  :items="CollegeMPs"
                  class="elevation-1"
                  dense
                >
                  <template v-slot:item.actions="{ item }">
                    <v-btn
                      icon
                      color="error"
                      small
                      @click="
                        manage_college_manpowerDelete(
                          item.mcm_times,
                          item.mcm_years,
                          item.mcm_id_position
                        )
                      "
                    >
                      <v-icon small>mdi-delete</v-icon>
                    </v-btn>
                  </template>
                </v-data-table>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            large
            outlined
            @click="addmanage_college_manpowerdialog = false"
          >
            <v-icon left>mdi-close</v-icon>
            ยกเลิก
          </v-btn>
          <v-btn
            large
            color="success"
            @click="addmanage_college_manpowerSubmit"
          >
            <v-icon left>mdi-content-save</v-icon>
            บันทึก
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Edit Dialog -->
    <v-dialog
      v-model="editmanage_college_manpowerdialog"
      persistent
      max-width="900px"
    >
      <v-card>
        <v-card-title class="warning white--text">
          <v-icon left color="white">mdi-pencil</v-icon>
          แก้ไขเลขที่ตำแหน่ง
        </v-card-title>
        <v-card-text class="pt-4">
          <v-form ref="editmanage_college_manpowerform" lazy-validation>
            <v-row>
              <v-col cols="12" md="6">
                <h3>{{ editmanage_college_manpower.college_name }}</h3>
              </v-col>
              <v-col cols="12" md="6">
                <h3>
                  เลขที่ตำแหน่ง:
                  {{ editmanage_college_manpower.mcm_id_position }}
                </h3>
              </v-col>

              <v-col cols="12">
                <v-autocomplete
                  :items="branchs"
                  item-text="name_branch"
                  item-value="id_branch"
                  outlined
                  label="สาขาวิชา"
                  v-model="editmanage_college_manpower.mcm_id_branch"
                  required
                  :rules="[v => !!v || 'กรุณาเลือกสาขาวิชา']"
                >
                  <template v-slot:item="{ item }">
                    <v-list-item-content>
                      <v-list-item-title>
                        {{ item.id_branch }} : {{ item.name_branch }}
                      </v-list-item-title>
                    </v-list-item-content>
                  </template>
                </v-autocomplete>
              </v-col>

              <v-col cols="12">
                <v-data-table
                  :loading="loading"
                  :headers="headersCollegeBranch"
                  :items="CollegeMPs"
                  class="elevation-1"
                  dense
                >
                  <template v-slot:item.actions="{ item }">
                    <v-btn
                      icon
                      color="info"
                      small
                      @click="
                        mamCollegeQuery(
                          item.mcm_times,
                          item.mcm_years,
                          item.mcm_college_code
                        )
                      "
                    >
                      <v-icon small>mdi-account-search</v-icon>
                    </v-btn>
                  </template>
                </v-data-table>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            large
            outlined
            @click="editmanage_college_manpowerdialog = false"
          >
            <v-icon left>mdi-close</v-icon>
            ยกเลิก
          </v-btn>
          <v-btn
            large
            color="warning"
            @click="editmanage_college_manpowerSubmit"
          >
            <v-icon left>mdi-pencil</v-icon>
            บันทึก
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Delete Dialog -->
    <v-dialog
      v-model="deletemanage_college_manpowerdialog"
      persistent
      max-width="500px"
    >
      <v-card>
        <v-card-title class="error white--text">
          <v-icon left color="white">mdi-delete</v-icon>
          ยืนยันการลบ
        </v-card-title>
        <v-card-text class="pt-4">
          <v-alert type="warning" prominent>
            <strong>คำเตือน!</strong><br />
            คุณต้องการลบรายการนี้หรือไม่?
          </v-alert>
          <div class="text-h6 mt-3">
            {{ editmanage_college_manpower.mcm_times }}/{{
              editmanage_college_manpower.mcm_years
            }}
            : {{ editmanage_college_manpower.college_name }} <br />
            เลขที่ตำแหน่ง {{ editmanage_college_manpower.mcm_id_position }}
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            large
            outlined
            @click="deletemanage_college_manpowerdialog = false"
          >
            <v-icon left>mdi-close</v-icon>
            ยกเลิก
          </v-btn>
          <v-btn
            large
            color="error"
            @click="deletemanage_college_manpowerSubmit"
          >
            <v-icon left>mdi-delete</v-icon>
            ลบ
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- CSV Import Dialog -->
    <v-dialog
      v-model="manage_college_manpowerCSVdialog"
      persistent
      max-width="600px"
    >
      <v-card>
        <v-card-title class="success white--text">
          <v-icon left color="white">mdi-file-import</v-icon>
          นำเข้าข้อมูล CSV
        </v-card-title>
        <v-card-text class="pt-4">
          <v-form ref="manage_college_manpowerCSVdialogform" lazy-validation>
            <v-row>
              <v-col cols="12">
                <v-btn
                  outlined
                  block
                  large
                  color="info"
                  to="/admin/manage_college_manpower_import/"
                  target="_blank"
                >
                  <v-icon left>mdi-download</v-icon>
                  ดาวน์โหลดแบบฟอร์ม
                </v-btn>
              </v-col>

              <v-col cols="12">
                <v-file-input
                  v-model="file2"
                  accept=".csv"
                  color="success"
                  counter
                  label="ไฟล์ CSV"
                  placeholder="เลือกไฟล์ .csv"
                  prepend-icon="mdi-paperclip"
                  outlined
                  :show-size="1000"
                >
                  <template v-slot:selection="{ text }">
                    <v-chip color="success" dark label small>
                      {{ text }}
                    </v-chip>
                  </template>
                </v-file-input>
              </v-col>

              <v-col cols="12">
                <v-btn
                  block
                  large
                  color="success"
                  @click="csvManpowerSubmit"
                  :disabled="!file2"
                >
                  <v-icon left>mdi-upload</v-icon>
                  นำเข้าข้อมูล
                </v-btn>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            large
            outlined
            @click="manage_college_manpowerCSVdialog = false"
          >
            <v-icon left>mdi-close</v-icon>
            ปิด
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Statistics Summary Dialog -->
    <v-dialog
      v-model="manage_college_manpowerCountDialog"
      persistent
      max-width="1000px"
    >
      <v-card>
        <v-card-title class="info white--text">
          <v-icon left color="white">mdi-chart-pie</v-icon>
          สรุปสถิติตำแหน่งแยกตามวิทยาลัย
        </v-card-title>
        <v-card-text class="pt-4">
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="ค้นหา"
            single-line
            hide-details
            dense
            filled
            class="mb-4"
          />

          <v-data-table
            :loading="loading"
            :headers="headersCount"
            :items="manage_college_manpowerCount"
            :search="search"
            class="elevation-1"
          >
            <template v-slot:item.actions="{ item }">
              <v-btn
                icon
                color="info"
                @click="
                  mamCollegeQuery(
                    item.mcm_times,
                    item.mcm_years,
                    item.mcm_college_code
                  )
                "
              >
                <v-icon>mdi-account-search</v-icon>
              </v-btn>
            </template>
          </v-data-table>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            large
            outlined
            @click="manage_college_manpowerCountDialog = false"
          >
            <v-icon left>mdi-close</v-icon>
            ปิด
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import ManageAssistantTeacherBar from "../../../components/admin/manageAssistantTeacherBar.vue";
import VueApexCharts from "vue-apexcharts";

export default {
  name: "HRvecManageCollegeManpower",

  components: {
    ManageAssistantTeacherBar,
    apexchart: VueApexCharts
  },

  data() {
    return {
      loading: true,
      ApiKey: "HRvec2021",

      // View Mode
      viewMode: "admin", // admin or display
      isFullscreen: false,
      autoRefresh: false,
      refreshInterval: null,
      currentTime: "",
      showRefreshSnackbar: false,

      // Search & Filter
      search: "",
      statusFilter: null,

      // Dialogs
      addmanage_college_manpowerdialog: false,
      editmanage_college_manpowerdialog: false,
      deletemanage_college_manpowerdialog: false,
      manage_college_manpowerCSVdialog: false,
      manage_college_manpowerCountDialog: false,

      // Data
      manage_college_manpowers: [],
      addmanage_college_manpower: {},
      editmanage_college_manpower: {},
      manage_college_manpowerCount: [],
      colleges: [],
      jor18s: [],
      CollegeMPs: [],
      branchs: [],
      periodassteachs: {},
      file2: null,

      // Table Headers
      headers: [
        { text: "รอบที่", value: "mcm_times", align: "center", width: "80px" },
        { text: "ปี", value: "mcm_years", align: "center", width: "80px" },
        { text: "เขต", value: "college_dif", align: "center", width: "80px" },
        { text: "ภาค", value: "region_name", align: "left" },
        { text: "จังหวัด", value: "province_name", align: "left" },
        { text: "วิทยาลัย", value: "college_name", align: "left" },
        { text: "เลขที่ตำแหน่ง", value: "mcm_id_position", align: "center" },
        { text: "สาขาวิชา", value: "mcm_id_branch", align: "center" },
        { text: "ชื่อสาขา", value: "name_branch", align: "left" },
        { text: "สถานะ", value: "whoBooking", align: "center" },
        { text: "แก้ไข", value: "actions", align: "center", sortable: false },
        { text: "ลบ", value: "action_s", align: "center", sortable: false }
      ],

      headersCount: [
        { text: "รอบที่", value: "mcm_times", align: "center" },
        { text: "ปี", value: "mcm_years", align: "center" },
        { text: "รหัส", value: "mcm_college_code", align: "center" },
        { text: "วิทยาลัย", value: "college_name", align: "left" },
        { text: "จำนวน", value: "collegeGroup", align: "center" },
        { text: "แสดง", value: "actions", align: "center" }
      ],

      headersCollegeBranch: [
        { text: "รอบที่", value: "mcm_times", align: "center" },
        { text: "ปี", value: "mcm_years", align: "center" },
        { text: "วิทยาลัย", value: "college_name", align: "left" },
        { text: "เลขที่ตำแหน่ง", value: "mcm_id_position", align: "center" },
        { text: "รหัสสาขา", value: "mcm_id_branch", align: "center" },
        { text: "สาขาวิชา", value: "name_branch", align: "left" },
        { text: "ลบ", value: "actions", align: "center", sortable: false }
      ],

      statusFilterOptions: [
        { text: "ทั้งหมด", value: null },
        { text: "ว่าง", value: "available" },
        { text: "จองแล้ว", value: "booked" }
      ]
    };
  },

  computed: {
    statistics() {
      const total = this.manage_college_manpowers.length;
      const booked = this.manage_college_manpowers.filter(
        p => p.mcm_id_card_booking && p.mcm_id_card_booking !== ""
      ).length;
      const available = total - booked;

      // Count unique colleges
      const uniqueColleges = new Set(
        this.manage_college_manpowers.map(p => p.mcm_college_code)
      );

      return {
        total,
        booked,
        available,
        bookedPercent: total > 0 ? Math.round((booked / total) * 100) : 0,
        availablePercent: total > 0 ? Math.round((available / total) * 100) : 0,
        colleges: uniqueColleges.size
      };
    },

    filteredPositions() {
      let filtered = this.manage_college_manpowers;

      if (this.statusFilter) {
        filtered = filtered.filter(position => {
          switch (this.statusFilter) {
            case "available":
              return (
                !position.mcm_id_card_booking ||
                position.mcm_id_card_booking === ""
              );
            case "booked":
              return (
                position.mcm_id_card_booking &&
                position.mcm_id_card_booking !== ""
              );
            default:
              return true;
          }
        });
      }

      return filtered;
    },

    // Branch Statistics
    branchStats() {
      const stats = {};
      this.manage_college_manpowers.forEach(position => {
        if (!stats[position.mcm_id_branch]) {
          stats[position.mcm_id_branch] = {
            name: position.name_branch,
            total: 0,
            booked: 0,
            available: 0
          };
        }
        stats[position.mcm_id_branch].total++;
        if (position.mcm_id_card_booking) {
          stats[position.mcm_id_branch].booked++;
        } else {
          stats[position.mcm_id_branch].available++;
        }
      });
      return stats;
    },

    // Region Statistics
    regionStats() {
      const stats = {};
      this.manage_college_manpowers.forEach(position => {
        const region = position.region_name || "ไม่ระบุ";
        if (!stats[region]) {
          stats[region] = {
            total: 0,
            booked: 0,
            available: 0
          };
        }
        stats[region].total++;
        if (position.mcm_id_card_booking) {
          stats[region].booked++;
        } else {
          stats[region].available++;
        }
      });
      return stats;
    },

    // Top Colleges
    topColleges() {
      const collegeMap = {};
      this.manage_college_manpowers.forEach(position => {
        const code = position.mcm_college_code;
        if (!collegeMap[code]) {
          collegeMap[code] = {
            college_code: code,
            college_name: position.college_name,
            province_name: position.province_name,
            total: 0,
            booked: 0,
            available: 0,
            usagePercent: 0
          };
        }
        collegeMap[code].total++;
        if (position.mcm_id_card_booking) {
          collegeMap[code].booked++;
        } else {
          collegeMap[code].available++;
        }
      });

      // Calculate usage percent
      Object.values(collegeMap).forEach(college => {
        college.usagePercent =
          college.total > 0
            ? Math.round((college.booked / college.total) * 100)
            : 0;
      });

      // Sort by total and return top 15
      return Object.values(collegeMap)
        .sort((a, b) => b.total - a.total)
        .slice(0, 15);
    },

    // Chart Data - Donut
    donutChartSeries() {
      return [this.statistics.booked, this.statistics.available];
    },

    donutChartOptions() {
      return {
        chart: {
          type: "donut",
          fontFamily: "Sarabun, sans-serif"
        },
        labels: ["จองแล้ว", "ว่าง"],
        colors: ["#4CAF50", "#FF9800"],
        legend: {
          position: "bottom",
          fontSize: "14px"
        },
        plotOptions: {
          pie: {
            donut: {
              size: "65%",
              labels: {
                show: true,
                total: {
                  show: true,
                  label: "ทั้งหมด",
                  fontSize: "18px",
                  fontWeight: 600
                }
              }
            }
          }
        },
        dataLabels: {
          enabled: true,
          formatter: function(val, opts) {
            return opts.w.config.series[opts.seriesIndex];
          }
        },
        tooltip: {
          y: {
            formatter: function(val) {
              return val + " ตำแหน่ง";
            }
          }
        }
      };
    },

    // Chart Data - Branch Bar
    branchBarChartSeries() {
      const branches = Object.keys(this.branchStats)
        .sort((a, b) => this.branchStats[b].total - this.branchStats[a].total)
        .slice(0, 10);

      return [
        {
          name: "จองแล้ว",
          data: branches.map(b => this.branchStats[b].booked)
        },
        {
          name: "ว่าง",
          data: branches.map(b => this.branchStats[b].available)
        }
      ];
    },

    branchBarChartOptions() {
      const branches = Object.keys(this.branchStats)
        .sort((a, b) => this.branchStats[b].total - this.branchStats[a].total)
        .slice(0, 10);

      return {
        chart: {
          type: "bar",
          stacked: true,
          fontFamily: "Sarabun, sans-serif",
          toolbar: {
            show: true
          }
        },
        plotOptions: {
          bar: {
            horizontal: false,
            dataLabels: {
              total: {
                enabled: true,
                style: {
                  fontSize: "13px",
                  fontWeight: 900
                }
              }
            }
          }
        },
        xaxis: {
          categories: branches.map(b => this.branchStats[b].name),
          labels: {
            style: {
              fontSize: "12px"
            }
          }
        },
        yaxis: {
          title: {
            text: "จำนวน (ตำแหน่ง)"
          }
        },
        legend: {
          position: "top",
          fontSize: "14px"
        },
        colors: ["#4CAF50", "#FF9800"],
        dataLabels: {
          enabled: true
        },
        tooltip: {
          y: {
            formatter: function(val) {
              return val + " ตำแหน่ง";
            }
          }
        }
      };
    },

    // Chart Data - Region Bar
    regionBarChartSeries() {
      const regions = Object.keys(this.regionStats);
      return [
        {
          name: "ทั้งหมด",
          data: regions.map(r => this.regionStats[r].total)
        },
        {
          name: "จองแล้ว",
          data: regions.map(r => this.regionStats[r].booked)
        },
        {
          name: "ว่าง",
          data: regions.map(r => this.regionStats[r].available)
        }
      ];
    },

    regionBarChartOptions() {
      const regions = Object.keys(this.regionStats);
      return {
        chart: {
          type: "bar",
          fontFamily: "Sarabun, sans-serif",
          toolbar: {
            show: true
          }
        },
        plotOptions: {
          bar: {
            horizontal: true,
            dataLabels: {
              position: "top"
            }
          }
        },
        xaxis: {
          categories: regions
        },
        legend: {
          position: "top",
          fontSize: "14px"
        },
        colors: ["#2196F3", "#4CAF50", "#FF9800"],
        dataLabels: {
          enabled: true
        },
        tooltip: {
          y: {
            formatter: function(val) {
              return val + " ตำแหน่ง";
            }
          }
        }
      };
    },

    // Chart Data - Area (Usage Trend)
    areaChartSeries() {
      return [
        {
          name: "อัตราการใช้งาน",
          data: [65, 72, 78, 85, 88, this.statistics.bookedPercent]
        }
      ];
    },

    areaChartOptions() {
      return {
        chart: {
          type: "area",
          fontFamily: "Sarabun, sans-serif",
          toolbar: {
            show: false
          }
        },
        dataLabels: {
          enabled: false
        },
        stroke: {
          curve: "smooth",
          width: 3
        },
        xaxis: {
          categories: [
            "เดือน 1",
            "เดือน 2",
            "เดือน 3",
            "เดือน 4",
            "เดือน 5",
            "ปัจจุบัน"
          ]
        },
        yaxis: {
          title: {
            text: "เปอร์เซ็นต์"
          },
          min: 0,
          max: 100
        },
        fill: {
          type: "gradient",
          gradient: {
            shadeIntensity: 1,
            opacityFrom: 0.7,
            opacityTo: 0.3
          }
        },
        colors: ["#4CAF50"],
        tooltip: {
          y: {
            formatter: function(val) {
              return val + "%";
            }
          }
        }
      };
    },

    // Mini Charts for Admin Mode
    miniBarChartSeries() {
      const branches = Object.keys(this.branchStats)
        .sort((a, b) => this.branchStats[b].total - this.branchStats[a].total)
        .slice(0, 5);

      return [
        {
          name: "ตำแหน่ง",
          data: branches.map(b => this.branchStats[b].total)
        }
      ];
    },

    miniBarChartOptions() {
      const branches = Object.keys(this.branchStats)
        .sort((a, b) => this.branchStats[b].total - this.branchStats[a].total)
        .slice(0, 5);

      return {
        chart: {
          type: "bar",
          fontFamily: "Sarabun, sans-serif",
          toolbar: { show: false }
        },
        plotOptions: {
          bar: {
            horizontal: true,
            dataLabels: {
              position: "top"
            }
          }
        },
        xaxis: {
          categories: branches.map(b => this.branchStats[b].name)
        },
        colors: ["#2196F3"],
        dataLabels: {
          enabled: true
        }
      };
    },

    miniDonutChartOptions() {
      return {
        chart: {
          type: "donut",
          fontFamily: "Sarabun, sans-serif"
        },
        labels: ["จองแล้ว", "ว่าง"],
        colors: ["#4CAF50", "#FF9800"],
        legend: {
          position: "bottom",
          fontSize: "12px"
        },
        plotOptions: {
          pie: {
            donut: {
              size: "60%"
            }
          }
        },
        dataLabels: {
          enabled: false
        }
      };
    }
  },

  watch: {
    autoRefresh(val) {
      if (val) {
        this.startAutoRefresh();
      } else {
        this.stopAutoRefresh();
      }
    }
  },

  async mounted() {
    await this.initialize();
    this.updateTime();
    setInterval(this.updateTime, 1000);
  },

  beforeDestroy() {
    this.stopAutoRefresh();
  },

  methods: {
    async initialize() {
      try {
        await this.periodassteachQuery();
        await this.branchQuery();
        await this.mcmCountQuery();
        await this.manage_college_manpowerQueryAll();
        await this.collegeQuery();
      } catch (error) {
        console.error("Initialization error:", error);
        Swal.fire({
          icon: "error",
          title: "เกิดข้อผิดพลาด",
          text: "ไม่สามารถโหลดข้อมูลได้"
        });
      }
    },

    updateTime() {
      const now = new Date();
      const options = {
        year: "numeric",
        month: "long",
        day: "numeric",
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
        hour12: false
      };
      this.currentTime = now.toLocaleDateString("th-TH", options);
    },

    // Auto Refresh
    toggleAutoRefresh() {
      this.autoRefresh = !this.autoRefresh;
    },

    startAutoRefresh() {
      this.refreshInterval = setInterval(async () => {
        await this.manage_college_manpowerQueryAll();
        this.showRefreshSnackbar = true;
      }, 10000);
    },

    stopAutoRefresh() {
      if (this.refreshInterval) {
        clearInterval(this.refreshInterval);
        this.refreshInterval = null;
      }
    },

    // Fullscreen
    toggleFullscreen() {
      if (!document.fullscreenElement) {
        document.documentElement.requestFullscreen();
        this.isFullscreen = true;
      } else {
        if (document.exitFullscreen) {
          document.exitFullscreen();
          this.isFullscreen = false;
        }
      }
    },

    // API Methods
    async collegeQuery() {
      const result = await this.$http.post("college.php", {
        ApiKey: this.ApiKey
      });
      this.colleges = result.data;
    },

    async jor18Query() {
      const result = await this.$http.post("jor18.php", {
        ApiKey: this.ApiKey,
        j18college_code: this.addmanage_college_manpower.mcm_college_code
      });
      this.jor18s = result.data;
    },

    async mamCollegeQuery(mcm_times, mcm_years, mcm_college_code) {
      const result = await this.$http.post("manage_college_manpower.php", {
        ApiKey: this.ApiKey,
        mcm_times,
        mcm_years,
        mcm_college_code
      });
      this.manage_college_manpowers = result.data;
      this.manage_college_manpowerCountDialog = false;
    },

    async CollegeMPQuery() {
      const result = await this.$http.post("manage_college_manpower.php", {
        ApiKey: this.ApiKey,
        mcm_times: this.periodassteachs.periodAssTeachTimes,
        mcm_years: this.periodassteachs.periodAssTeachYear,
        mcm_college_code: this.addmanage_college_manpower.mcm_college_code
      });
      this.CollegeMPs = result.data;
    },

    async mcmCountQuery() {
      const result = await this.$http.post("manage_college_manpower.php", {
        ApiKey: this.ApiKey,
        mcm_times: this.periodassteachs.periodAssTeachTimes,
        mcm_years: this.periodassteachs.periodAssTeachYear,
        mcm_count: "Ok"
      });
      this.manage_college_manpowerCount = result.data;
    },

    async periodassteachQuery() {
      const result = await this.$http.post("periodassteach.php", {
        ApiKey: this.ApiKey,
        periodAssTeachEnablePro: "1"
      });
      this.periodassteachs = result.data;
    },

    async branchQuery() {
      const result = await this.$http.post("branch.php", {
        ApiKey: this.ApiKey
      });
      this.branchs = result.data;
    },

    async manage_college_manpowerQueryAll() {
      this.loading = true;
      try {
        const result = await this.$http.post("manage_college_manpower.php", {
          ApiKey: this.ApiKey,
          mcm_times: this.periodassteachs.periodAssTeachTimes,
          mcm_years: this.periodassteachs.periodAssTeachYear
        });
        this.manage_college_manpowers = result.data;
      } finally {
        this.loading = false;
      }
    },

    // Dialog Methods
    async manage_college_manpowerAdd() {
      this.addmanage_college_manpower = {};
      this.CollegeMPs = [];
      this.addmanage_college_manpowerdialog = true;
    },

    async addmanage_college_manpowerSubmit() {
      if (!this.$refs.addmanage_college_manpowerform.validate()) {
        return;
      }

      this.addmanage_college_manpower.ApiKey = this.ApiKey;
      this.addmanage_college_manpower.mcm_times = this.periodassteachs.periodAssTeachTimes;
      this.addmanage_college_manpower.mcm_years = this.periodassteachs.periodAssTeachYear;
      this.addmanage_college_manpower.mcm_id_card_booking = "";
      this.addmanage_college_manpower.mcm_status = "";

      const result = await this.$http.post(
        "manage_college_manpower.insert.php",
        this.addmanage_college_manpower
      );

      if (result.data.status) {
        Swal.fire({
          icon: "success",
          title: "บันทึกข้อมูลเรียบร้อย",
          showConfirmButton: false,
          timer: 1500
        });
        await this.manage_college_manpowerQueryAll();
        await this.CollegeMPQuery();
      } else {
        Swal.fire({
          icon: "warning",
          title: "บันทึกข้อมูลผิดพลาด",
          showConfirmButton: false,
          timer: 1500
        });
      }
    },

    async manage_college_manpowerEdit(mcm_times, mcm_years, mcm_id_position) {
      const result = await this.$http.post("manage_college_manpower.php", {
        ApiKey: this.ApiKey,
        mcm_times,
        mcm_years,
        mcm_id_position
      });
      this.editmanage_college_manpower = result.data;

      const resultmcm = await this.$http.post("manage_college_manpower.php", {
        ApiKey: this.ApiKey,
        mcm_times: this.editmanage_college_manpower.mcm_times,
        mcm_years: this.editmanage_college_manpower.mcm_years,
        mcm_college_code: this.editmanage_college_manpower.mcm_college_code
      });
      this.CollegeMPs = resultmcm.data;
      this.editmanage_college_manpowerdialog = true;
    },

    async editmanage_college_manpowerSubmit() {
      if (!this.$refs.editmanage_college_manpowerform.validate()) {
        return;
      }

      this.editmanage_college_manpower.ApiKey = this.ApiKey;
      const result = await this.$http.post(
        "manage_college_manpower.update.php",
        this.editmanage_college_manpower
      );

      if (result.data.status) {
        Swal.fire({
          icon: "success",
          title: "แก้ไขข้อมูลเรียบร้อย",
          showConfirmButton: false,
          timer: 1500
        });
        await this.manage_college_manpowerQueryAll();
      } else {
        Swal.fire({
          icon: "warning",
          title: "ดำเนินการผิดพลาด",
          showConfirmButton: false,
          timer: 1500
        });
      }

      const resultmcm = await this.$http.post("manage_college_manpower.php", {
        ApiKey: this.ApiKey,
        mcm_times: this.editmanage_college_manpower.mcm_times,
        mcm_years: this.editmanage_college_manpower.mcm_years,
        mcm_college_code: this.editmanage_college_manpower.mcm_college_code
      });
      this.CollegeMPs = resultmcm.data;
    },

    async manage_college_manpowerDelete(mcm_times, mcm_years, mcm_id_position) {
      const result = await this.$http.post("manage_college_manpower.php", {
        ApiKey: this.ApiKey,
        mcm_times,
        mcm_years,
        mcm_id_position
      });
      this.editmanage_college_manpower = result.data;
      this.deletemanage_college_manpowerdialog = true;
    },

    async deletemanage_college_manpowerSubmit() {
      this.editmanage_college_manpower.ApiKey = this.ApiKey;
      const result = await this.$http.post(
        "manage_college_manpower.delete.php",
        this.editmanage_college_manpower
      );

      if (result.data.status) {
        Swal.fire({
          icon: "success",
          title: "ลบข้อมูลเรียบร้อย",
          showConfirmButton: false,
          timer: 1500
        });
      } else {
        Swal.fire({
          icon: "warning",
          title: "ดำเนินการผิดพลาด",
          showConfirmButton: false,
          timer: 1500
        });
      }

      await this.manage_college_manpowerQueryAll();
      this.deletemanage_college_manpowerdialog = false;
      await this.CollegeMPQuery();
    },

    async csvManpowerSubmit() {
      if (!this.file2) {
        Swal.fire({
          icon: "warning",
          title: "กรุณาเลือกไฟล์",
          showConfirmButton: false,
          timer: 1500
        });
        return;
      }

      const formData = new FormData();
      const filename = Date.now() + ".manpower.csv";
      formData.append("file", this.file2);
      formData.append("filename", "../HRvecfiles/" + filename);
      formData.append("ApiKey", this.ApiKey);

      const result = await this.$http.post(
        "manage_college_manpowerCSV.php",
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data"
          }
        }
      );

      if (result.data.status) {
        Swal.fire({
          icon: "success",
          title: "นำเข้าข้อมูลเรียบร้อย",
          showConfirmButton: false,
          timer: 1500
        });
        await this.manage_college_manpowerQueryAll();
      } else {
        Swal.fire({
          icon: "warning",
          title: "นำเข้าข้อมูลผิดพลาด",
          showConfirmButton: false,
          timer: 1500
        });
      }

      this.manage_college_manpowerCSVdialog = false;
      this.file2 = null;
    },

    async manage_college_manpowerCSV() {
      this.manage_college_manpowerCSVdialog = true;
    },

    async manage_college_manpowerTotal() {
      await this.mcmCountQuery();
      this.manage_college_manpowerCountDialog = true;
    }
  }
};
</script>

<style scoped>
@import url("https://fonts.googleapis.com/css2?family=Sarabun:wght@300;400;600;700&display=swap");

* {
  font-family: "Sarabun", sans-serif;
}

.group-header {
  background: linear-gradient(90deg, #f5f5f5 0%, #ffffff 100%);
  padding: 12px 16px !important;
  font-size: 16px;
}

.admin-mode {
  padding-top: 20px;
}

.display-mode {
  height: calc(100vh - 48px);
  overflow-y: auto;
  background: #f5f5f5;
}

.v-card {
  transition: transform 0.2s, box-shadow 0.2s;
}

.v-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1) !important;
}

.v-data-table >>> tbody tr:hover {
  background-color: rgba(0, 0, 0, 0.02) !important;
}

@media (max-width: 960px) {
  .text-h3 {
    font-size: 2rem !important;
  }

  .text-h4 {
    font-size: 1.5rem !important;
  }
}

@media (max-width: 600px) {
  .v-data-table {
    font-size: 12px;
  }

  .text-h3 {
    font-size: 1.5rem !important;
  }
}

::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

::-webkit-scrollbar-track {
  background: #f1f1f1;
}

::-webkit-scrollbar-thumb {
  background: #888;
  border-radius: 4px;
}

::-webkit-scrollbar-thumb:hover {
  background: #555;
}
</style>
